import { useState } from 'react';
import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import NewsCard from '@/components/feature/NewsCard';
import { getSortedByTime } from '@/utils/newsUtils';
import { news } from '@/mocks/news';

export default function LatestNews() {
  const [active, setActive] = useState('all');

  const filtered = active === 'all' ? getSortedByTime(news) : getSortedByTime(news.filter((n) => n.categoryId === active));
  const visible = active === 'all' ? filtered.slice(0, 8) : filtered.slice(0, 6);
  const activeCategory = categories.find((c) => c.id === active);

  const tabs = [{ id: 'all', name: '全部' }, ...categories.map((c) => ({ id: c.id, name: c.name }))];

  return (
    <section className="mt-8">
      <div className="flex flex-wrap items-center gap-3 mb-4">
        <h2 className="text-lg font-bold font-heading text-foreground-950">最新资讯</h2>
        <div className="flex flex-wrap items-center gap-1.5">
          {tabs.map((t) => (
            <button
              key={t.id}
              type="button"
              onClick={() => setActive(t.id)}
              className={`px-3 py-1.5 rounded-full text-xs font-medium transition-colors cursor-pointer whitespace-nowrap ${
                active === t.id
                  ? 'bg-primary-500 text-primary-50'
                  : 'bg-background-100 text-foreground-600 hover:bg-primary-50 hover:text-primary-600'
              }`}
            >
              {t.name}
            </button>
          ))}
        </div>
      </div>

      {visible.length === 0 ? (
        <div className="rounded-lg border border-dashed border-background-300 bg-background-50 py-16 text-center">
          <p className="text-sm text-foreground-500">暂无最新新闻，敬请期待</p>
        </div>
      ) : (
        <div className="flex flex-col gap-4">
          {visible.map((article) => (
            <NewsCard key={article.id} article={article} layout="row" />
          ))}
        </div>
      )}

      {active !== 'all' && activeCategory && (
        <div className="mt-6 flex justify-center">
          <Link
            to={`/category/${activeCategory.id}`}
            className="inline-flex items-center gap-1.5 h-10 px-5 rounded-md border border-background-300 bg-background-50 text-sm font-medium text-foreground-800 hover:border-primary-300 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            查看更多「{activeCategory.name}」资讯
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      )}
    </section>
  );
}